import React from 'react';
import { Link } from 'react-router-dom';

import { Button, SvgIconUrl } from 'common/components';

import { useBowser, useI18n } from 'common/hooks';
import { ModalAction } from 'common/redux/modal/initialState';
import svgIcons from 'common/svgIcons';

import { routes } from 'routes/routes.constants';

import './index.css';

const ConfirmVerificationLvlPopup: React.FC<React.PropsWithChildren<{ onCancel: () => void }>> = ({ onCancel }) => {
  const { isDesktop } = useBowser();
  const { translate } = useI18n();

  return (
    <div className='confirmation-verification-popup'>
      <div className='icon-shadow'>
        <SvgIconUrl symbol={svgIcons.PersonaIco()} />
      </div>
      <h5 className='confirmation-verification-popup__title'>
        {translate('mobile:confirmation-verification-popup:title')}
      </h5>

      <p className='confirmation-verification-popup__descr'>
        <span>{translate('mobile:confirmation-verification-popup:descr1')}</span>
        <br />
        <span>{translate('mobile:confirmation-verification-popup:descr2')}</span>
      </p>

      <div className='confirmation-verification-popup__btns'>
        <Button small={isDesktop} outline onClick={onCancel}>
          {translate('mobile:confirmation-verification-popup:cancel-btn')}
        </Button>

        <Link to={routes.getVerificationLevelPage()}>
          <Button medium={isDesktop}>{translate('mobile:confirmation-verification-popup:continue-btn')}</Button>
        </Link>
      </div>
    </div>
  );
};

const ConfirmVerificationPopupComponent = (props: ModalAction) => ({
  component: <ConfirmVerificationLvlPopup onCancel={() => props?.onCloseHandler?.()} />,
  hideCloseIcon: true,
  wrapperClassName: 'modal-verification modal__no-scroll',
});

export default ConfirmVerificationPopupComponent;
